/* Loumimi : soulignés « au crayon » qui se dessinent quand le mot arrive à l'écran.
   Dans les textes du thème, entourer le mot de [[ ]] : la section le transforme en <span class="bb-mark">. */
(() => {
  const PATHS = [
    'M3 9.5c22-3.6 47-5.2 76-4.4 33 .9 64 3.4 118 1.2',
    'M2 7.8c31 2.4 61-2.6 93-1.6 34 1 66 3.8 103-.4',
    'M4 10c26-4.8 58-6 90-5 38 1.2 70 2.6 103 1.4'
  ];
  const svg = i => `<svg class="bb-mark__svg" viewBox="0 0 200 14" preserveAspectRatio="none" aria-hidden="true">
    <path d="${PATHS[i % 3]}" pathLength="1"/><path class="bb-mark__2" d="${PATHS[(i + 1) % 3]}" pathLength="1"/></svg>`;
  const init = () => {
    const marks = [...document.querySelectorAll('.bb-mark:not([data-ready])')];
    marks.forEach((m, i) => { m.dataset.ready = ''; m.insertAdjacentHTML('beforeend', svg(i)); });
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      marks.forEach(m => m.classList.add('is-drawn')); return;
    }
    const io = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-drawn'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -12% 0px', threshold: 1 });
    marks.forEach(m => io.observe(m));
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
